import { render, staticRenderFns } from "./RegcodeDisplay.vue?vue&type=template&id=f053c60c&scoped=true&"
import script from "./RegcodeDisplay.vue?vue&type=script&lang=ts&"
export * from "./RegcodeDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./RegcodeDisplay.vue?vue&type=style&index=0&id=f053c60c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f053c60c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VLabel,VTooltip})
